import { useState } from "react";
import { Link } from "react-router-dom";
import addDotsToPrice from "../price-format";
import DetailForm from "./DetailForm";
import Guarantee from "./Guarantee";

import "./DetailProduct.css";
import "../../pages/Products.css";

const DetailProduct = (props) => {
  const [imageIndex, setImageIndex] = useState(0);

  return (
    <section className="section_detail_wrap container">
      <nav aria-label="breadcrumb">
        <ol
          style={{ "--bs-breadcrumb-bg": "#f0f0f0" }}
          className="breadcrumb ps-3 pt-2 pb-3 mb-4"
        >
          <li className="breadcrumb-item">
            <Link to="/">Trang chủ</Link>
          </li>
          <li className="breadcrumb-item">{props.product.category}</li>
          <li className="breadcrumb-item active" aria-current="page">
            {props.product.name}
          </li>
        </ol>
      </nav>

      <div className="row g-4">
        {/* Image List and Selected Image */}
        <div className="col-12 col-lg-6 d-flex">
          <div className="d-flex flex-column align-items-start me-3">
            {props.imagesList.map((img, i) => (
              <div className="mb-2" key={i} onClick={() => setImageIndex(i)}>
                <img
                  src={img}
                  alt={`${props.product.name}-${i}`}
                  className="detail-photolist img-fluid"
                />
              </div>
            ))}
          </div>
          <div className="flex-grow-1">
            <img
              src={props.imagesList[imageIndex]}
              alt={`${props.product.name}-${imageIndex}`}
              className="detail-photo_click"
            />
          </div>
        </div>

        {/* Product Details */}
        <div className="col-12 col-lg-6">
          <h4>{props.product.name}</h4>
          <h5 className="text-danger fst-italic">
            {addDotsToPrice(props.product.price)}
          </h5>
          <p className="mt-2 mb-0">
            <span className="detail_category">Danh mục: </span>
            <span className="text-primary">{props.product.category}</span>
          </p>
          <p className="mt-0 mb-0">
            <span>Store: </span>
            <span
              className={
                props.product.count > 0 ? "text-primary" : "text-danger"
              }
            >
              {props.product.count > 0 ? props.product.count : "Hết hàng"}
            </span>
          </p>
          <DetailForm product={props.product} />
          <Guarantee />
        </div>
      </div>
    </section>
  );
};

export default DetailProduct;
